import { render, staticRenderFns } from "./ProfilePayment.vue?vue&type=template&id=0aa58800&scoped=true&"
import script from "./ProfilePayment.vue?vue&type=script&lang=js&"
export * from "./ProfilePayment.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePayment.vue?vue&type=style&index=0&id=0aa58800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa58800",
  null
  
)

export default component.exports